// Data for WhatsApp Lead Form Project

export const companyStats = [
  { number: '30+', label: 'Anos de Experiência' },
  { number: '5000+', label: 'Projetos Realizados' },
  { number: '200+', label: 'Clientes Ativos' },
  { number: '98%', label: 'Satisfação' }
];

export const whyChooseUs = [
  {
    id: 1,
    title: '30 Anos de Expertise',
    description: 'Três décadas de experiência e conhecimento em comunicação e marketing',
    icon: 'Award'
  },
  {
    id: 2,
    title: 'Foco em Resultados',
    description: 'Estratégias orientadas para conversão e ROI mensurável',
    icon: 'Target'
  },
  {
    id: 3,
    title: 'Soluções 360°',
    description: 'Atendimento completo do diagnóstico à execução e análise',
    icon: 'Zap'
  },
  {
    id: 4,
    title: 'Marketing Imobiliário',
    description: 'Especialistas no setor imobiliário com cases de sucesso',
    icon: 'Building'
  }
];

export const services = [
  {
    id: 1,
    title: 'Branding & Identidade',
    description: 'Construção e fortalecimento de marca com identidade visual impactante',
    features: [
      'Branding institucional e digital',
      'Rebranding e revitalização',
      'Naming e nomenclatura',
      'Assinaturas institucionais'
    ],
    icon: 'Palette'
  },
  {
    id: 2,
    title: 'Gestão de Mídias Sociais',
    description: 'Presença digital estratégica com conteúdo que engaja e converte',
    features: [
      'Gestão completa de redes sociais',
      'Criação de conteúdo',
      'Análise de perfis',
      'Produção de vídeos'
    ],
    icon: 'Share2'
  },
  {
    id: 3,
    title: 'Marketing de Performance',
    description: 'Campanhas pagas otimizadas para máximo retorno sobre investimento',
    features: [
      'Google Ads',
      'Facebook & Instagram Ads',
      'LinkedIn Ads',
      'Mídia programática'
    ],
    icon: 'TrendingUp'
  },
  {
    id: 4,
    title: 'Marketing de Conteúdo',
    description: 'Conteúdo estratégico que atrai, educa e converte seu público',
    features: [
      'Inbound Marketing',
      'Blog e artigos',
      'E-mail marketing',
      'Nutrição de leads'
    ],
    icon: 'FileText'
  },
  {
    id: 5,
    title: 'Sites & E-commerce',
    description: 'Plataformas digitais modernas, responsivas e otimizadas para conversão',
    features: [
      'Sites institucionais',
      'Landing pages',
      'E-commerce completo',
      'SEO otimizado'
    ],
    icon: 'Globe'
  },
  {
    id: 6,
    title: 'Assessoria de Comunicação',
    description: 'Consultoria estratégica completa para posicionamento de mercado',
    features: [
      'Diagnóstico e planejamento',
      'Estratégia de comunicação',
      'Posicionamento de imagem',
      'Aculturamento digital'
    ],
    icon: 'MessageSquare'
  }
];

export const portfolio = [
  {
    id: 1,
    title: 'Unimed Piracicaba',
    category: 'Saúde',
    description: 'Campanhas institucionais e digitais para cooperativa médica',
    tags: ['Branding', 'Digital', 'Social Media'],
    image: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=600&h=400&fit=crop',
    link: 'https://senhaonline.com.br/portfolio/unimed-campanha-apoio-aos-profissionais-de-saude/'
  },
  {
    id: 2,
    title: 'CLQ - Laboratórios',
    category: 'Saúde',
    description: 'Identidade visual e marketing digital completo',
    tags: ['Website', 'Branding', 'Marketing'],
    image: 'https://images.unsplash.com/photo-1581093588401-fbb62a02f120?w=600&h=400&fit=crop',
    link: 'https://senhaonline.com.br/portfolio/clq-redes-sociais/'
  },
  {
    id: 3,
    title: 'ESCAD Rental',
    category: 'Construção',
    description: 'Branding e estratégia de comunicação com foco em cultura de valor e propósito',
    tags: ['Branding', 'Estratégia', 'Propósito'],
    image: 'https://customer-assets.emergentagent.com/job_f2b18a42-25f4-4837-bb60-b0e2886cc8b3/artifacts/3p6wpbq0_ESCAD.jpeg',
    link: 'https://senhaonline.com.br/portfolio/rebranding-institucional-escad-rental/'
  },
  {
    id: 4,
    title: 'ALLTERRA Feiras e Eventos',
    category: 'Eventos',
    description: 'Projeto completo para feira ANDAV SP',
    tags: ['Eventos', 'Feira', 'Stand'],
    image: 'https://customer-assets.emergentagent.com/job_mude-o-jogo/artifacts/1uwj4b4p_ALLTERR.jpg',
    link: 'https://senhaonline.com.br/portfolio/projeto-allterra-feira-andav-sp/'
  },
  {
    id: 5,
    title: 'EXX Consultoria Imobiliária',
    category: 'Imobiliário',
    description: 'Branding e gestão Real State',
    tags: ['Branding', 'Imobiliário', 'Consultoria'],
    image: 'https://customer-assets.emergentagent.com/job_mude-o-jogo/artifacts/i33s9jk7_EXX.jpg',
    link: 'https://senhaonline.com.br/portfolio/branding-exx-gestao-real-state/'
  },
  {
    id: 6,
    title: 'BELEZA GREGA Saúde e Estética',
    category: 'Estética e Saúde',
    description: 'Branding e identidade conceitual para clínica de estética',
    tags: ['Branding', 'Identidade', 'Saúde'],
    image: 'https://images.unsplash.com/photo-1595871151608-bc7abd1caca3?w=600&h=400&fit=crop',
    link: 'https://senhaonline.com.br/portfolio/branding-beleza-grega-identidade-conceitual/'
  },
  {
    id: 7,
    title: 'BIOCENTER Campanha Social',
    category: 'Saúde',
    description: 'Campanha Junho Vermelho - Doação de sangue',
    tags: ['Campanha', 'Social', 'Saúde'],
    image: 'https://customer-assets.emergentagent.com/job_mude-o-jogo/artifacts/alm81acu_BIO.jpg',
    link: 'https://senhaonline.com.br/portfolio/campanha-junho-vermelho-biocenter/'
  },
  {
    id: 8,
    title: 'VIVA Lounge Bar',
    category: 'Restaurante & Bar',
    description: 'Branding completo para restaurante e bar',
    tags: ['Branding', 'Restaurante', 'Bar'],
    image: 'https://customer-assets.emergentagent.com/job_mude-o-jogo/artifacts/oz7pbpvv_VIVA.jpg',
    link: 'https://senhaonline.com.br/portfolio/viva-lounge-bar-20190618175805/'
  },
  {
    id: 9,
    title: 'Jardim Araucárias',
    category: 'Marketing Imobiliário',
    description: 'Book imobiliário e material de vendas',
    tags: ['Imobiliário', 'Book', 'Design'],
    image: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=600&h=400&fit=crop',
    link: 'https://senhaonline.com.br/portfolio/jardim-araucarias-book-imobiliario/'
  },
  {
    id: 10,
    title: 'Allterra Agronegócio',
    category: 'Agronegócio',
    description: 'Reposicionamento e nova arquitetura de marca para novos produtos',
    tags: ['Rebranding', 'Arquitetura de Marca', 'Social Media'],
    image: 'https://images.unsplash.com/photo-1625246333195-78d9c38ad449?w=600&h=400&fit=crop',
    link: 'https://senhaonline.com.br/portfolio/branding-digital-allterra/'
  },
  {
    id: 11,
    title: 'W&MED',
    category: 'Saúde',
    description: 'Apresentação do novo logo e identidade visual',
    tags: ['Logo', 'Identidade Visual', 'Branding'],
    image: 'https://images.unsplash.com/photo-1551076805-e1869033e561?w=600&h=400&fit=crop',
    link: 'https://senhaonline.com.br/portfolio/apresentacao-do-novo-logo-da-w-amp-med/'
  },
  {
    id: 12,
    title: 'Rigava',
    category: 'Corporativo',
    description: 'Rebranding e arquitetura de marca completa',
    tags: ['Rebranding', 'Arquitetura de Marca', 'Design'],
    image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=600&h=400&fit=crop',
    link: 'https://senhaonline.com.br/portfolio/rebranding-arquitetura-de-marca-rigava/'
  },
  {
    id: 13,
    title: 'Brasfer Metalúrgica',
    category: 'Indústria',
    description: 'Rebranding e estratégia de comunicação industrial',
    tags: ['Rebranding', 'B2B', 'Industrial'],
    image: 'https://customer-assets.emergentagent.com/job_f2b18a42-25f4-4837-bb60-b0e2886cc8b3/artifacts/i3h96h5s_SUCATA.jpeg',
    link: 'https://www.portalbrasfer.com.br/'
  },
  {
    id: 14,
    title: 'Biocenter Laboratórios',
    category: 'Saúde',
    description: 'Marketing digital e presença online',
    tags: ['Digital', 'Website', 'Social Media'],
    image: 'https://customer-assets.emergentagent.com/job_f2b18a42-25f4-4837-bb60-b0e2886cc8b3/artifacts/bbl4zx9k_BIOCENTER.jpeg',
    link: 'https://biocenterlaboratorios.com.br/'
  },
  {
    id: 15,
    title: 'Cincor Americana',
    category: 'Saúde',
    description: 'Campanhas e comunicação visual',
    tags: ['Branding', 'Comunicação', 'Saúde'],
    image: 'https://customer-assets.emergentagent.com/job_f2b18a42-25f4-4837-bb60-b0e2886cc8b3/artifacts/2rkirpev_CINCOR.jpeg',
    link: 'https://cincoramericana.com.br/'
  }
];

export const contactInfo = {
  phone: '(19) 98133-3233',
  phoneLink: '+5519981333233',
  email: 'sac@senhaonline.com.br',
  location: 'Piracicaba - SP',
  website: 'www.senhaonline.com.br',
  pdfLink: 'https://customer-assets.emergentagent.com/job_whatsapp-lead-form/artifacts/17ptj789_Appresenta%C3%A7%C3%A3o_senha%20comunica%C3%A7%C3%A3o._2026.pdf'
};
